/**
 * 设置侧边栏 Composable
 * 用于全局控制设置侧边栏的显示和隐藏
 */

// 全局状态 - 控制侧边栏显示
const visible = ref(false)

/**
 * 使用设置侧边栏
 */
export function useSettingsSidebar() {
  /**
   * 打开侧边栏
   */
  const open = () => {
    visible.value = true
  }

  /**
   * 关闭侧边栏
   */
  const close = () => {
    visible.value = false
  }

  /**
   * 切换侧边栏显示状态
   */
  const toggle = () => {
    visible.value = !visible.value
  }

  return {
    visible,
    open,
    close,
    toggle,
  }
}
